/**
 * Safely extract error message string from API error responses.
 * Handles both string details (HTTPException) and array details (Pydantic 422).
 */
export function getApiErrorMessage(error, fallback = 'Une erreur est survenue') {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(d => (typeof d === 'object' && d.msg) ? d.msg : String(d)).join(', ');
  }
  if (typeof detail === 'object' && detail.msg) return detail.msg;
  return fallback;
}
